module.exports = __webpack_public_path__ + "img/s_2.96b35f80.png";